import React, { useState } from 'react';
import styled from 'styled-components';

import { ICON_CLOSE } from 'assets/icons';
import Row from 'components/common/Row';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import AuthButton from 'components/Button/AuthButton';
import InputForm from 'containers/Login/components/InputForm';
import { useLoginHooks } from 'containers/Login/hooks/useLoginHooks';
import BottomToast from 'components/Modal/BottomToast';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
`;

const FindPasswordContainer = () => {
  const {
    isOpenBottomToast,
    setIsOpenBottomToast,
    handleOnChangeFindPasswordModal,
    handleFindPassword,
  } = useLoginHooks();

  const [email, setEmail] = useState<string>('');

  const handleOnchangeEmail = (key: string, value: string) => {
    setEmail(value);
  };

  return (
    <React.Fragment>
      <Column
        gap="40px"
        align="center"
        style={{ padding: '20px 20px 40px 20px' }}
      >
        <Column gap="32px">
          <Column gap="8px" align="flex-start">
            <Text color="#1B1C1E" size="20px" weight={700}>
              비밀번호 찾기
            </Text>
            <Text color="#70737C" weight={400}>
              가입하신 이메일 주소를 입력해 주세요. 비밀번호 재설정 링크를
              보내드리겠습니다.
            </Text>
          </Column>
          <InputContainer>
            <InputForm
              label="아이디(이메일)"
              type="text"
              styleType="large"
              target="email"
              onChange={handleOnchangeEmail}
            />
          </InputContainer>
        </Column>
        <AuthButton
          name="비밀번호 재설정"
          isAbled={email !== ''}
          onClick={() => {
            if (email !== '') {
              handleFindPassword(email, handleOnChangeFindPasswordModal);
            }
          }}
        />
      </Column>
      {isOpenBottomToast && (
        <BottomToast
          title="비밀번호 재설정 메일이 전송되었습니다."
          description="새로운 비밀번호를 설정하신 후, 다시 로그인해 주세요."
          onAcceptText="확인"
          onAccept={() => {
            setIsOpenBottomToast(false);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default FindPasswordContainer;
